import { Button, useTheme } from "@mui/material";
import { MouseEvent, ReactNode } from "react";
import { tokens } from "../theme";

interface DashboardActionButtonProps {
  endIcon?: ReactNode;
  icon?: ReactNode;
  label: string;
  minWidth?: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

const DashboardActionButton = ({
  endIcon,
  icon,
  label,
  minWidth = "129px",
  onClick,
}: DashboardActionButtonProps) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Button
      variant="contained"
      disableElevation
      endIcon={endIcon}
      onClick={onClick}
      startIcon={icon}
      sx={{
        minWidth,
        height: "41px",
        px: "18px",
        bgcolor: colors.primary.bgChart,
        borderRadius: "83px",
        color: colors.primary.text,
        fontSize: "12px",
        fontWeight: 700,
        lineHeight: 1,
        textTransform: "none",
        whiteSpace: "nowrap",
        "&:hover": {
          bgcolor: colors.primary.bgChart,
        },
        ".MuiButton-startIcon": {
          mr: "8px",
        },
        ".MuiButton-endIcon": {
          ml: "8px",
        },
      }}
    >
      {label}
    </Button>
  );
};

export default DashboardActionButton;
